import { HeroSection } from "@/components/home/HeroSection";
import { ExpertiseSection } from "@/components/home/ExpertiseSection";
import { MethodologySection } from "@/components/home/MethodologySection";
import { ProjectsSection } from "@/components/home/ProjectsSection";
import { SoftwareSection } from "@/components/home/SoftwareSection";
import { PartnersSection } from "@/components/home/PartnersSection";
import { ContactSection } from "@/components/home/ContactSection";
import { SEO } from "@/components/layout/SEO";
import { useLanguage } from "@/components/LanguageContext";

export default function Home() {
  const { t } = useLanguage();

  return (
    <>
      <SEO 
        title={t("Accueil", "Home")}
        description={t(
          "AVISIUM Solutions Group est un cabinet de conseil premium spécialisé dans la planification de la mobilité, les infrastructures de transport et l'intelligence territoriale.",
          "AVISIUM Solutions Group is a premium consulting firm specialized in mobility planning, transport infrastructure, and territorial intelligence."
        )}
      />
      <HeroSection />
      <ExpertiseSection />
      <MethodologySection />
      <ProjectsSection />
      <SoftwareSection />
      <PartnersSection />
      <ContactSection />
    </>
  );
}
